/* eslint-disable */

class Notifications {
    constructor() {
        this.container = document.querySelector('#notifications');

        if(!this.container) {
            return;
        }

        this.notifications = this.container.querySelectorAll('article.notification');
        this.enabledNotifications = [];
    }

    init(helpers) {
        const self = this;

        self.helpers = helpers;

        let i;

        if(!self.container) {
            return;
        }

        self.container.hidden = true;

        if(self.notifications.length < 1) {
            return;
        }

        let numberOfNotifications = self.notifications.length;

        for(let notification of self.notifications) {
            let heading = notification.querySelector('h3'),
                key = notification.id,
                button,
                span;

            if(sessionStorage.getItem(key) === 'false') {
                continue;
            }

            self.enabledNotifications.push(key);

            span = document.createElement('span');
            span.classList.add('notification__dismiss-button__text');
            button = self.helpers.createButton('');
            button.setAttribute('aria-describedby', heading.id);
            button.className = 'notification__dismiss-button';
            button.appendChild(span);
            span.appendChild(document.createTextNode(i18n.Notifications.dismiss + ' '));

            notification.insertBefore(button, notification.children[0].nextElementSibling);

            button.addEventListener('click', function(e) {
                let id = e.currentTarget.parentElement.id;
                self.dismissNotification(id);
            });

            sessionStorage.setItem(key, 'true');
            self.container.hidden = false;
        }

        setTimeout(function() {
            if('true' === sessionStorage.getItem('notifications-announced')) {
                return;
            }

            wp.a11y.speak(wp.i18n.sprintf(wp.i18n._n(i18n.Notifications.oneNotification, i18n.Notifications.xNotifications, numberOfNotifications, 'study_ontario_canada' ), numberOfNotifications));

            sessionStorage.setItem('notifications-announced', 'true');
        }, 5000, numberOfNotifications);
    }

    dismissNotification(key) {
        const self = this;
        
        let notification = document.querySelector('#' + key),
            listItem = notification.parentElement;

        if(sessionStorage.getItem(key)) {
            listItem.hidden = true;
            sessionStorage.setItem(key, 'false');
            self.helpers.removeItemFromArray(self.enabledNotifications, key);
        }

        if(!self.enabledNotifications.length) {
            self.container.hidden = true;
        }

        wp.a11y.speak(i18n.Notifications.notificationDismissed);
    }

}

export default Notifications;